<template>
  <div class="form" v-if="address">
    <div class="form__head">
      <div class="form__title form__title_white mb10">
        {{$t('forms.addAddress')}}
        <button type="reset" class="form__address-close" @click="close">
          <img src="@/assets/images/close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="form__content">
      <div class="form-item form-item_flex form-item_w100">
        <autocomplete-input
          :autocompleteValue="autocompleteValue"
          :isUpdate="canUpdate"
          :placeholder="$t('forms.street')"
          @fill="fill"
          @blur="onAutocompleteInputBlur"
          class="mb24"
        />

        <div class="form-item__getLocation" @click="getCurrentPosition">
          <img src="@/assets/images/getAddress.svg" alt />
        </div>
      </div>

      <div class="form-item mb24">
        <el-input
          :placeholder="$t('forms.apartment')"
          type="text"
          v-model="address.apartment"
          autocomplete="off"
        ></el-input>
      </div>

      <div class="form-item mb24">
        <el-input
          :placeholder="$t('forms.description')"
          type="textarea"
          v-model="address.description"
          autocomplete="off"
        ></el-input>
      </div>

      <div class="form-item form-item_flex form-item_center">
        <button
          type="reset"
          class="btn btn_upper btn_w240"
          @click="done"
          :disabled="!isValid || isSubmitted"
          :class="{
                        'btn_disabled': !isValid || isSubmitted
                    }"
        >{{$t('buttons.add')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import autocompleteInput from "@/components/base/autocomplete/index";
import { required } from "vuelidate/lib/validators";

export default {
  name: "add-address",
  components: {
    autocompleteInput
  },
  computed: {
    ...mapGetters({
      address: "address/address",
      type: "address/type",
      isUpdate: "address/isUpdate"
    }),

    isValid() {
      return !this.$v.$invalid;
    }
  },
  validations: {
    autocompleteValue: {
      required
    }
  },
  data() {
    return {
      autocompleteValue: "",
      mutatedAddress: null,
      accuracy: null,
      canUpdate: false,
      isSubmitted: false
    };
  },
  methods: {
    ...mapMutations({
      setState: "address/setState",
      addAddress: "address/addAddress",
      updateAddress: "address/updateAddress"
    }),
    ...mapActions({
      add: "address/add",
      update: "address/update",
      fetch: "address/fetch"
    }),
    onAutocompleteInputBlur(value) {
      this.autocompleteValue = value;
    },
    fill({ autocompleteValue, address }) {
      this.mutatedAddress = address;
      this.mutatedAddress.id = this.address.id;

      this.autocompleteValue = autocompleteValue;
    },
    pressButton() {
      this.isSubmitted = true;
    },
    unpressButton() {
      this.isSubmitted = false;
    },
    async done() {
      if (this.mutatedAddress == null) this.mutatedAddress = this.address;
      this.pressButton();

      await this.makeRequest();
      await this.fetch();

      this.close();
      this.clear();
    },
    prepareForm() {
      this.mutatedAddress.description = this.address.description;
      this.mutatedAddress.apartment = this.address.apartment;

      return this.mutatedAddress;
    },
    async makeRequest() {
      if (this.isUpdate) {
        await this.update(this.prepareForm());
      } else {
        await this.add(this.prepareForm());
      }
    },
    clear() {
      this.autocompleteValue = null;
      this.setState({
        key: "address",
        value: {
          street: "",
          house: ""
        }
      });

      setTimeout(() => {
        this.unpressButton();
      }, 300);
    },
    close() {
      this.clear();
      this.$emit("close");
    },

    getCurrentPosition() {
      const vm = this;

      function success(pos) {
        var crd = pos.coords;
        vm.accuracy = pos.coords.accuracy;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          {
            location: {
              lat: crd.latitude,
              lng: crd.longitude
            }
          },
          (results, status) => {
            const result = results[0];

            const address = {
              postcode: result.address_components[5].long_name,
              country: result.address_components[3].long_name,
              city: result.address_components[2].short_name,
              street: result.address_components[1].short_name,
              house: parseInt(result.address_components[0].short_name),
              entrance: 1,
              apartment: 1,
              description: "",
              longitude: result.geometry.location.lng(),
              latitude: result.geometry.location.lat()
            };

            vm.fill({
              autocompleteValue: `${address.street} ${address.house} ${address.postcode} ${address.city}`,
              address
            });

            vm.canUpdate = true;
          }
        );
      }

      function error(err) {
        // console.warn('ERROR(' + err.code + '): ' + err.message);
      }

      this.id = navigator.geolocation.watchPosition(success, error, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    }
  },
  created() {
    if (this.address && this.address.street == null) {
      return;
    }

    this.autocompleteValue = `${this.address.street} ${this.address.house}`;
    this.autocompleteValue =
      this.autocompleteValue == " " ? "" : this.autocompleteValue;
  },
  destroyed() {
    navigator.geolocation.clearWatch(this.id);
  }
};
</script>

<style lang="scss" scoped>
.form__address-close {
  background: transparent;
  border: none;
  position: absolute;
  right: 0;
  padding: 0;
  outline: none;
  cursor: pointer;
}
</style>